import logo from "../../assets/urmate-logo.webp";
import { IconWyloguj } from "../icons/index.js";
import { ProfileMenu } from "./ProfileMenu.js";
import { ThemeToggle } from "./ThemeToggle.js";

/**
 * L-3, L-5, L-5a, L-7, L-11, L-14.
 *
 * L-14 i pulapka owijek: ZADNA pojedyncza kontrolka headera nie jest owinieta
 * w blokowy <div>. Owijka lapie baseline-gap i robi sie wyzsza od przycisku,
 * przez co align-items: center wypycha widoczny przycisk w gore. Responsywna
 * widocznosc nadajemy wprost na przycisku (display none/inline-flex w CSS).
 *
 * Logo importujemy z client/src/assets/, nie z design-system/images/. .dockerignore
 * wyklucza design-system, wiec import stamtad przeszedlby lokalnie i wywalil budowanie
 * obrazu. Import przez modul (a nie sciezka w public/) sprawia, ze brakujacy plik
 * jest bledem budowania, a nie cicha dziura na produkcji.
 */

interface Props {
  username: string;
  onSignOut: () => void | Promise<void>;
  menuOtwarte: boolean;
  onPrzelaczMenu: () => void;
  refHamburgera: React.RefObject<HTMLButtonElement | null>;
}

export function AppHeader({
  username,
  onSignOut,
  menuOtwarte,
  onPrzelaczMenu,
  refHamburgera,
}: Props): React.JSX.Element {
  return (
    <header className="app-header">
      <div className="header-left">
        {/* L-11: hamburger PRZED logiem. Znika od 1024px, gdzie sidebar jest staly. */}
        <button
          type="button"
          ref={refHamburgera}
          className={`hbtn hbtn--icon hamburger${menuOtwarte ? " is-open" : ""}`}
          aria-label="Menu nawigacji"
          aria-expanded={menuOtwarte}
          aria-controls="sidebar"
          onClick={onPrzelaczMenu}
        >
          <span className="hamburger__bars" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>

        <img className="brand" src={logo} alt="urmate.ai" />

        {/* L-5a: nazwa automatyzacji jako wyciszony podpis obok logo, tylko desktop. */}
        <span className="brand-name">ConvoLens</span>
      </div>

      <div className="header-right">
        <ThemeToggle wariant="pasek" />

        {/* B-7: "Wyloguj" to kontrolka headera, NIE primary. Primary w headerze
            konkurowalby z glowna akcja widoku i lamal B-2. */}
        <button type="button" className="hbtn hbtn--text bar-logout" onClick={() => void onSignOut()}>
          <IconWyloguj size={16} />
          Wyloguj
        </button>

        <ProfileMenu username={username} onSignOut={onSignOut} />
      </div>
    </header>
  );
}
